/* eslint-disable no-fallthrough */
import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  ADD_ONE,
  ADD_MANY,
  REMOVE_ONE,
  SET_DISCOUNT,
  EMPTY_CART,
  UPDATE_CART_ITEM,
  SET_PENDING_ADD_PRODUCT_ID,
  IS_LOADING_ALL_PRODUCTS,
  IS_LOADING_ADD_PRODUCT,
} from '../types'

import { agregarCotizacion } from '../actions/cotizacionActions'
import { Formatter } from 'Utils/Formatter'

const initialState = {
  isLoadingAllProducts: false,
  isLoadingAddProduct: {
    active: false,
    id: null,
  },
  cart: [],
  pendingAddProductId: false,
}

export default function cartReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_TO_CART:
      if (action?.payload?.product?.Price) {
        const productId =
          action.payload?.product?.ProductId ||
          action.payload?.product?.productId
        if (
          state.cart.findIndex(product => product.ProductId === productId) !==
          -1
        ) {
          const cart = state.cart.reduce((cartAcc, product) => {
            if (product.ProductId === productId) {
              cartAcc.push({
                ...action.payload.product,
              })
            } else {
              cartAcc.push(product)
            }
            return cartAcc
          }, [])
          return { ...state, cart }
        }
        return {
          ...state,
          cart: [
            ...state.cart,
            {
              ...action.payload.product,
              Quantity: action.payload.qty,
            },
          ],
        }
      }

    case REMOVE_FROM_CART:
      return {
        ...state,
        cart: state.cart.filter(
          product => product.ProductId !== action.payload.product.ProductId
        ),
      }

    case ADD_ONE:
      if (action?.payload?.product?.Price) {
        return {
          ...state,
          cart: state.cart.map(p => {
            if (p.ProductId === action.payload.product.ProductId) {
              const Quantity = action.payload.newQuantity
              const DiscountAmount =
                p.BasePrice - p.Price < 0
                  ? 0
                  : Number(
                      Formatter.Money(p.BasePrice - p.Price, {
                        withFormat: false,
                      })
                    )
              const DiscountPct =
                ((p.BasePrice - p.Price) * 100) / p.Price < 0
                  ? 0
                  : ((p.BasePrice - p.Price) * 100) / p.Price
              return {
                ...p,
                Quantity,
                Amount: p.Price * Quantity,
                Tax: p.Price * Quantity * p.TaxCategoryValue,
                AmountWithTax:
                  p.Price * Quantity + p.Price * Quantity * p.TaxCategoryValue,
                DiscountAmount,
                DiscountAmountLocal: DiscountAmount,
                DiscountPct,
              }
            }
            return p
          }),
        }
      }

    case ADD_MANY:
      return {
        ...state,
        cart: state.cart.map(p => {
          if (p.ProductId === action.payload.product.ProductId) {
            const Quantity = action.payload.numberOfProd
            const DiscountAmount =
              p.BasePrice - p.Price < 0
                ? 0
                : Number(
                    Formatter.Money(p.BasePrice - p.Price, {
                      withFormat: false,
                    })
                  )
            const DiscountPct =
              ((p.BasePrice - p.Price) * 100) / p.Price < 0
                ? 0
                : ((p.BasePrice - p.Price) * 100) / p.Price
            return {
              ...p,
              Quantity,
              Amount: p.Price * Quantity,
              Tax: p.Price * Quantity * p.TaxCategoryValue,
              AmountWithTax:
                p.Price * Quantity + p.Price * Quantity * p.TaxCategoryValue,
              DiscountAmount,
              DiscountAmountLocal: DiscountAmount,
              DiscountPct,
            }
          }
          return p
        }),
      }

    case REMOVE_ONE:
      return {
        ...state,
        cart: state.cart
          .map(p => {
            if (p.ProductId === action.payload.product.ProductId) {
              const Quantity = action.payload.newQuantity
              const DiscountAmount =
                p.BasePrice - p.Price < 0
                  ? 0
                  : Number(
                      Formatter.Money(p.BasePrice - p.Price, {
                        withFormat: false,
                      })
                    )
              const DiscountPct =
                ((p.BasePrice - p.Price) * 100) / p.Price < 0
                  ? 0
                  : ((p.BasePrice - p.Price) * 100) / p.Price
              const updatedProduct = {
                ...p,
                Quantity,
                Amount: p.Price * Quantity,
                Tax: p.Price * Quantity * p.TaxCategoryValue,
                AmountWithTax:
                  p.Price * Quantity + p.Price * Quantity * p.TaxCategoryValue,
                DiscountAmount,
                DiscountAmountLocal: DiscountAmount,
                DiscountPct,
              }
              if (updatedProduct.Quantity > 0) {
                return updatedProduct
              }
              return null
            }
            return p
          })
          .filter(Boolean),
      }

    case SET_DISCOUNT:
      // eslint-disable-next-line no-case-declarations
      const productId = action.payload?.product?.ProductId
      if (
        state.cart.findIndex(product => product.ProductId === productId) !== -1
      ) {
        const cart = state.cart.map(product => {
          if (product.ProductId === productId) {
            product = {
              ...action.payload?.product,
              isPriceChanged: product.isPriceChanged,
            }
            return product
          } else {
            return product
          }
        })
        agregarCotizacion({ Lines: cart })
        return { ...state, cart }
      }
      return { ...state, cart: [...state.cart] }
    case EMPTY_CART:
      return { ...state, cart: [] }

    case IS_LOADING_ALL_PRODUCTS:
      return {
        ...state,
        isLoadingAllProducts: action.payload.isLoadingAllProducts,
      }
    case IS_LOADING_ADD_PRODUCT:
      return {
        ...state,
        isLoadingAddProduct: action.payload.isLoadingAddProduct,
      }
    case 'IS_PRICE_CHANGED':
      // eslint-disable-next-line no-case-declarations
      const changeCart = [
        ...state.cart.slice(0, action.payload.index),
        {
          ...state.cart[action.payload.index],
          isPriceChanged: action.payload.value,
        },
        ...state.cart.slice(action.payload.index + 1),
      ]

      return {
        ...state,
        cart: [...changeCart],
      }

    case UPDATE_CART_ITEM: {
      const { updatedFields, matchCriteria, productId } = action.payload
      return {
        ...state,
        cart: state.cart.map(item => {
          const isMatch = matchCriteria
            ? Object.entries(matchCriteria).every(([key, val]) => {
                const itemVal =
                  typeof item[key] === 'boolean'
                    ? !!item[key]
                    : String(item[key])
                const matchVal = typeof val === 'boolean' ? !!val : String(val)
                return itemVal === matchVal
              })
            : item.ProductId === productId
          return isMatch ? { ...item, ...updatedFields } : item
        }),
      }
    }

    case SET_PENDING_ADD_PRODUCT_ID:
      return {
        ...state,
        pendingAddProductId: action.payload,
      }
    default:
      return state
  }
}
